import { Button } from "flowbite-react";
import { Loader2 } from "lucide-react";
import { ReactNode } from "react";
import { useAppContext } from "src/layouts/App-Context";

type CustomButtonProps = {
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  className?: string;
  isLoading?: boolean;
  color?:string;
  size?:string;
  disable?:boolean;
  accessRight?: "isView" | "isEdit"; // Access right for the button
  children: ReactNode;
};

const CustomButton = ({
  onClick,
  type = "button",
  className = "",
  color,
  size,
  isLoading = false,
  disable = false,
  accessRight,
  children,
}: CustomButtonProps) => {
  const { rights } = useAppContext();
  if (accessRight && !rights?.[accessRight]) return null;
  return (
    <Button
      type={type}
      color={color}
      size={size}
      onClick={onClick}
      className={`rounded-xl ${className}`}
      disabled={isLoading||disable}
    >
      {isLoading ? <Loader2 className="animate-spin w-4 h-4" /> : children}
    </Button>
  );
};

export default CustomButton;
